import config from "@/config/config";

class CaptchaService {

  public getToken(): Promise<string> {
    return new Promise(resolve => {
      (window as any).grecaptcha.ready(() => {
        (window as any).grecaptcha.execute(config.recaptchaPublicToken, { action: 'createtransaction' }).then(function(token: string) {
          resolve(token)
        })
      })
    })
  }
}

const captchaService = new CaptchaService();

export {
  captchaService
};
